import {
  Box,
  Typography,
} from '@mui/material';
import { T, Icon } from './stitch';
import { formatDate } from './projectMeta';


// Transcript Card
function TranscriptCard({ meeting, onClick }) {
  const title = meeting.title || 'Meeting';
  const date = meeting.meeting_date ? formatDate(meeting.meeting_date) : null;
  const duration = meeting.duration ? `${meeting.duration} min` : '';

  return (
    <Box
      onClick={onClick}
      sx={{
        p: 3,
        borderRadius: '0.75rem',
        backgroundColor: T.emeraldBg,
        border: `1px solid ${T.emerald}40`,
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        '&:hover': { borderColor: T.emerald, backgroundColor: '#dcfce7' },
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box>
          <Typography variant="subtitle2" sx={{ fontFamily: T.font, fontWeight: 600 }}>{title}</Typography>
          <Box sx={{ display: 'flex', gap: 2, mt: 0.5 }}>
            {date && <Typography variant="caption" sx={{ fontFamily: T.fontBody, color: T.outline }}>{date}</Typography>}
            {duration && <Typography variant="caption" sx={{ fontFamily: T.fontBody, color: T.outline }}>{duration}</Typography>}
          </Box>
        </Box>
        <Icon name="open_in_new" size={16} sx={{ color: T.emerald }} />
      </Box>
    </Box>
  );
}

export default TranscriptCard;
